<template>
  <v-dialog v-model="show" width="40%">
    <v-card>
      <v-card-title class="pl-dialog__title">
        <h4>Раскрытие информации</h4>
      </v-card-title>

      <v-card-text>
        <p>
          <router-link :to="{ path: '/docs/readme.pdf' }" target="_blank">Документация</router-link>
        </p>
        <p>
          <router-link :to="{ path: '/docs/licence.pdf' }" target="_blank">Лицензионный договор</router-link>
        </p>
        <p>
          <router-link :to="{ path: '/docs/crminstruction.pdf' }" target="_blank">Инструкции</router-link>
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="pl-btn" @click="closeModal"> закрыть </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'MainHelperModal',
  model: {
    prop: 'isOpen',
    event: 'close',
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    show: {
      get() {
        return this.isOpen
      },
      set() {
        this.closeModal()
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit('close', false)
    },
  },
}
</script>
